module.exports = __webpack_public_path__ + "static/media/TrailContinues.0ab5c2f0.jpg";